document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tooltip').forEach(wrap => {
    const icon  = wrap.querySelector('.tooltip-icon');
    const close = wrap.querySelector('.tooltip-icon-hover-close');

    // Abrir/cerrar por click en el icono (útil en mobile). También quita el "force-hide".
    if (icon) {
      icon.addEventListener('click', () => {
        wrap.classList.toggle('is-open');
        wrap.classList.remove('force-hide');
      });
    }

    // Cerrar: oculta y desactiva el hover mientras el puntero siga encima
    if (close) {
      close.addEventListener('click', (e) => {
        e.stopPropagation();
        wrap.classList.remove('is-open'); // por si estaba abierto por click
        wrap.classList.add('force-hide'); // bloquea el hover temporalmente
      });
    }

    // Cuando el puntero salga del área, reactivamos el hover
    wrap.addEventListener('mouseleave', () => {
      wrap.classList.remove('force-hide');
    });
  });  

});